import React from "react"
import PropTypes from "prop-types"
import FontAwesome from "react-fontawesome"
import Select from "react-select"

import { getSelectDropdownOptions } from "../../helpers/sharedHelperFunctions"

import "./LocatedInSearchInput.scss"

const populateFieldWithUnitName = props => {
  const preSelectedUnit =
    props.unitId &&
    props.units.length > 0 &&
    props.units.find(u => u.id === props.unitId)
  return preSelectedUnit
    ? { label: preSelectedUnit.name, value: preSelectedUnit.value }
    : undefined
}

const clearRenderer = () => {
  return <FontAwesome className="clearInput" name={"times"} />
}

class LocatedInSearchInput extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      suggestions: this.props.units.map(unit => ({
        value: unit.id,
        label: unit.name,
      })),
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      suggestions: nextProps.units
        .map(unit => ({
          value: unit.id,
          label: unit.name,
        }))
        .sort((a, b) => (a.label > b.label ? 1 : -1)),
    }
  }

  onInputChange = inputChange => {
    this.setState({
      suggestions: getSelectDropdownOptions(inputChange, this.props.units),
    })
  }

  onChange = onChange => {
    this.setState({
      value: onChange,
    })
    this.props.updateLocation(onChange ? onChange.value : "")
  }

  render() {
    const currentSearchSelection = populateFieldWithUnitName(this.props)
    return (
      <div className="LocatedInSearchInput">
        <label for="UnitDropdown" className="label no-margin-bottom">
          In
        </label>
        <Select
          id="UnitDropdown"
          name="UnitDropdown"
          className="unit-dropdown"
          isSearchable={true}
          isClearable={true}
          defaultValue={currentSearchSelection}
          value={currentSearchSelection}
          onChange={this.onChange}
          onInputChange={this.onInputChange}
          filterOption={() => true}
          options={this.state.suggestions}
          placeholder="Entire Facility"
          clearRenderer={clearRenderer}
        />
      </div>
    )
  }
}

LocatedInSearchInput.propTypes = {
  unitId: PropTypes.string,
  units: PropTypes.array,
  facilityId: PropTypes.string,
  updateLocation: PropTypes.func,
}

LocatedInSearchInput.defaultProps = {
  unitId: "",
  units: [],
}

export default LocatedInSearchInput
